import React from 'react';
import { Tag } from '../types/tag/tag';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface TagContextProps {
  tags: Map<string, Tag>;
  setTags: (tags: Map<string, Tag>) => void;
  tagsLoading: boolean;
}

const defaultContext: TagContextProps = {
  tags: new Map(),
  setTags: () => {},
  tagsLoading: false,
};

export const TagContext = React.createContext<TagContextProps>(defaultContext);

interface TagState {
  items: Record<string, any>[];
  loading: boolean;
}

export const tagSlice = createSlice({
  name: 'tag',
  initialState: { items: [], loading: true } as TagState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<Tag[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<Tag[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
